import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { isEnabled } from "lib/@components/feature"
import { hasDemand } from "lib/authorization/has-demand"
import { FEATURE_FLAG_CONTENT_TRANSLATION } from "routes/schedule/plugins/translation/translation.runtime"
import { TranslationManagementPanel } from "./translation-management-panel"
import { PRIORITY_CONTENT, SECTION_CONTENT } from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"

registerSystemAdminTab(
    "Translation",
    <TranslationManagementPanel $lazy />,
    () => hasDemand("sfg20Admin") && isEnabled(FEATURE_FLAG_CONTENT_TRANSLATION),
    PRIORITY_CONTENT,
    "mdi:translate-variant",
    SECTION_CONTENT
)
